/**
 * Created by Prodaja1 on 12.5.2017..
 */
import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import { GuestData} from '../guest-data/guest-data'
import {UserData} from "../services/UserData";
import { AlertController } from 'ionic-angular';

@Component({
    selector: 'question4',
    templateUrl: 'question4.html'
})
export class Question4 {
    userData : UserData;

    constructor(public navCtrl: NavController, navParams: NavParams, private alertCtrl: AlertController) {
        this.userData = navParams.data;
    }



    checkGradesValues () {
        //$('input[type="radio"]:not(:checked)')
        var error=false;
        for(var key in this.userData) {
            if(this.userData.hasOwnProperty(key) && key.indexOf("answer4")>-1) {
                if(key=="answer4a4" || key=="answer4b6" || key=="answer4c5" || key=="answer4d4")
                    continue;
                else {
                    if(this.userData[key]=="") {
                        console.log(key)
                        document.getElementById(key).style.color="red";
                        error=true;
                    }
                    else {
                        document.getElementById(key).style.color = "#786a62";
                    }
                }
            }
        }
        // if (this.userData.answer4a1=='' || this.userData.answer4a2==''
        //     || this.userData.answer4a2=='' || this.userData.answer4a3==''
        //     || this.userData.answer4b1=='' || this.userData.answer4b2==''
        //     || this.userData.answer4b3=='' || this.userData.answer4b4==''
        //     || this.userData.answer4b5=='' || this.userData.answer4c1==''
        //     || this.userData.answer4c2=='' || this.userData.answer4c3==''
        //     || this.userData.answer4c4=='' || this.userData.answer4d1==''
        //     || this.userData.answer4d2=='' || this.userData.answer4d3=='')
        if (error) {
            let alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Please rate all the categories',
                buttons: ['OK']
            });
            alert.present();
        }
        else {

            // var link = 'http://www.lero.mint-media.hr/ankete/API/v1/handler.php';
            // var dataStringified = JSON.stringify({object: this.userData});
            // var dataObject = JSON.parse(dataStringified);
            // var headers = new Headers();
            // headers.append('Content-Type', 'applicaton/json');
            //
            // this.http.post(link, dataObject , headers).then(response => {
            //     console.log(response.status);
            //     console.log(response.data); // data received by server
            //     console.log(response.headers);
            //
            // })
            //     .catch(error => {
            //         console.log(error);
            //         console.log(error.status);
            //         console.log(error.error); // error message as string
            //         console.log(error.headers);
            //
            //     });

            this.navCtrl.push(GuestData, this.userData); //proceed to Results
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/question4/question4.ts